export default class HeaderLang{

    constructor(){
        this._ui();
    }


    _ui(){
        const $lang = document.querySelector('.js-headerLang');

        document.querySelector('.js-headerLang-btn').addEventListener('click', ()=>{
            $lang.classList.toggle('-active');
        });
    }
}